import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Field} from 'redux-form';

import {
  FieldDiv,
  FieldRow,
  Label
} from './CheckoutPage.style';

import RenderDatePicker from '../../components/ReduxForm/RenderDatePicker';
import RenderDropdownList from './RenderDropdownList';

const FutureOrder = ({
    date,
    futureTimes,
    isDatepickerDayBlocked,
    onDateChange,
    onTimeChange,
    openingTimes,
    serviceTypeValue
  }) => {
  return (
    <FieldRow>
      <FieldDiv>
        <Label for="date">
          <FormattedMessage id="checkout.futureOrderDay" />
          {serviceTypeValue && (
            <Field
              name="date"
              component={RenderDatePicker}
              date={date}
              openingTimes={openingTimes}
              serviceTypeValue={serviceTypeValue}
              onDateChange={onDateChange}
              isDayBlocked={isDatepickerDayBlocked}
            />
          )}
        </Label>
      </FieldDiv>
      <FieldDiv nomargin>
        <Label for="time">
          <FormattedMessage id="checkout.futureOrderTime" />
          <Field
            name="time"
            data={futureTimes}
            component={RenderDropdownList}
            onTimeChange={onTimeChange}
          />
        </Label>
      </FieldDiv>
    </FieldRow>
  );
};

FutureOrder.propTypes = {
  date: PropTypes.object.isRequired,
  futureTimes: PropTypes.object.isRequired,
  isDatepickerDayBlocked: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  openingTimes: PropTypes.object.isRequired,
  serviceTypeValue: PropTypes.string.isRequired
};

export default FutureOrder;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/FutureOrder.js